import React, { Component } from 'react';
import { Form , Table, Spin, Row, Col, Button, Icon} from 'antd';
// import { Link } from 'react-router-dom'
import './css/style.css';
// import { Bar} from 'react-chartjs-2';
import logo from './img/logo.png';
import _orderBy from 'lodash/orderBy'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import {HeaderContainer, BoxTableContainer, TableContainer} from '../pages/styled-components/index';

class Comprehend extends Component {
  state={
    event:[]
  }
  componentWillReceiveProps(nextProps) {
    const { events = [] } = nextProps.data
    const orderedEvents = _orderBy(events, ['_id'], ['desc'])
    this.setState({
      event: orderedEvents
    })
  }
    render() {
      if(!this.props.data.events){
        return <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'100vh' }}>
        <Spin tip="Loading..."/>
        </div>
      }   
        const { event } = this.state  
        const { events } = this.props.data
        // const title = events.map(event => (event.title))
        // const sumDistance = events.map(event => (event.sumDistance))
        // const donationAllshirt = events.map(event => (event.donationAllshirt))
        // const totalDistance = events.map(event => (event.totalDistance))

        const columns = [{
          title: 'Event',
          dataIndex: 'title',
          fixed: 'left',
          width: 160,
          key: 'event',
        }, {
          title: 'ยอดบริจาคเสื้อ(บาท)',
          dataIndex: 'donationAllshirt',
          key: 'donationAllshirt',
          render:(donationAllshirt)=>{
            console.log(donationAllshirt)
            const donationshirt  =parseFloat(donationAllshirt).toLocaleString();
            return donationshirt
          }
        }, {
          title: 'ยอดบริจาคการวิ่ง(บาท)',
          dataIndex: 'donationBykilo',
          key: 'sumDistance',
          render:(sumDistance, donationBykilo)=>{
            console.log(event)
            console.log('donationBykilo',donationBykilo)
            console.log('event.donationBykilo',event.donationBykilo)
            const total = events.sumDistance*events.donationBykilo
            const all  =parseFloat(total.toFixed(2)).toLocaleString();
            return all
            }
          }, {
            title: 'ระยะทางวิ่งทั้งหมด(Km)',
            dataIndex: 'totalDistance',
            key: 'totalDistance',
            render:(totalDistance)=>{
              const Distance  =parseFloat(totalDistance.toFixed(2)).toLocaleString();
              return Distance
            }
          }, {
            title: 'Action',
            key: 'action',
            render: (text, event, index) => (
              <span>
                <a href={`/chartEvent/${event.slug}`}>
                  <Button type="primary" ><Icon type="area-chart" size='small'/></Button>
                </a>
              </span>
            ),
          }];
          
          // const data = {
          //   labels: title,
          //   datasets: [
          //     {
          //       data: donationAllshirt,
          //       backgroundColor: "rgba(255, 99, 132, 0.6)",
          //       label: 'ยอดบริจาคเสื้อ(บาท)'
          //     },
          //     {
          //       data: sumDistance,
          //       backgroundColor: "rgba(54, 162, 235, 0.6)",
          //       label: 'ยอดบริจาคการวิ่ง(บาท)'
          //     },
          //     {
          //       data: totalDistance,
          //       backgroundColor: "rgba(255, 206, 86, 0.6)",
          //       label: 'ระยะทางวิ่งทั้งหมด(Km)'
          //     }
          //   ]
          // }
        
        return (
              <div>
                <Row>
                  <Col style={{marginTop:'100px'}} /> 
                  <Col className="header">
                    <HeaderContainer>
                      <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start'}}>
                        <img src={logo} alt="logo" />
                        <a href="/event" className='backhome'>
                          <strong>Event</strong>
                        </a>
                        <a href="/comprehendEvent" className='backhome'>
                          <strong>Report</strong>
                        </a>
                      </div>  
                    </HeaderContainer>   
                  </Col>
                </Row>
                <BoxTableContainer>
                  {/* <ChartAllContainer>  
                    <Bar
                      data={data} 
                      options={{ 
                        title:{
                            display: true,
                            text:'Graph Report Event',
                            fontSize: 25
                          },
                          legend:{
                            display: true,
                            position: 'bottom'
                          }
                      }}
                    />
                  </ChartAllContainer> */}
                </BoxTableContainer>
                <BoxTableContainer style={{marginTop:'40px'}}>
                  <TableContainer>
                    <Table rowKey='_id' columns={columns} dataSource={event} pagination={{ pageSize: 50 }} scroll={{ x: 728 }}/> 
                  </TableContainer>
                </BoxTableContainer>
              </div>
    );
  }
}

// export default (Complete);
const queryevents = gql`
  query queryevents{
    events {
      _id
      slug
      thumbnailUrl
      title
      startDate
      endDate
      totalDistance
      sumDistance
      modalContent
      donationAllshirt
      donationBykilo
    }
  }`

export default compose(
    Form.create() ,
    graphql(queryevents)
  )(Comprehend);





// WEBPACK FOOTER //
// ./src/components/pages/comprehend.js